import { Box, chakra, keyframes, Spinner, Stack, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import Header from '../../../../../components/Header/Header';
import { IoDocuments } from 'react-icons/io5';
import { FaClipboardList } from 'react-icons/fa';
import InputSelectMobile from '../../../../../components/Input/Mobile/Select';
import { useRequestResources } from '../../../../../services/hooks/Resources/useRequestResources';
import { useMemo, useState } from 'react';
import { IDataWheelPickerSelect } from '../../../../../components/Input/Mobile/Select/whellPicker';
import { useRequestSelectiveProcess } from '../../../../../services/hooks/SelectiveProcess/useRequestSelectiveProcess';
import ResourceListMobile from './ResourceList';
import { useSearchParams } from 'react-router-dom';
import CardHeaderMobile from '../../../../../components/Mobile/header';

const floatIn = keyframes`
      from { opacity: 0; transform: translateY(18px) scale(0.995); }  
  `;

const AnimatedBox = chakra(Box, {
  baseStyle: {
    animation: `${floatIn} 420ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

const ResourceMobilePage: React.FC = () => {
  const [params] = useSearchParams();
  const selectiveProcess = params.get('selective_process');

  const [selected, setSelected] = useState<IDataWheelPickerSelect>();
  const bgGradient = useColorModeValue('linear(to-br, gray.50, white)', 'linear(to-br, gray.900, gray.800)');
  const borderColor = useColorModeValue('gray.100', 'gray.700');

  const accent = '#222';

  const { data, isLoading } = useRequestResources();
  const spList = useRequestSelectiveProcess(undefined, undefined, true);

  const selectiveProcessList = useMemo(() => {
    const itens =
      (data &&
        data?.map((item) => ({
          id: item.selective_process_id,
          name: item.selective_process_name,
          createdAt: item?.selective_process_created_at?.us,
        }))) ||
      [];

    spList.data?.forEach((item) => {
      if (!itens.some((resource) => resource.id === item.id)) {
        itens.push({
          id: item.id,
          name: item.name,
          createdAt: item?.created_at?.us || '--',
        });
      }
    });

    itens.forEach((item) => {
      if (selectiveProcess === item.id) {
        setSelected({ id: item.id, name: item.name });
      }
    });

    return itens?.sort((a, b) => {
      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });
  }, [data, spList.data]);

  const listBySelectiveProcess = selected && selectiveProcessList?.find((resource) => resource.id === selected.id);

  const loading = isLoading;

  return (
    <Stack height="100%" w="100%" top={0} bg="white" gap={0}>
      <Header />
      <VStack mt={0} flex={1} overflowY="auto" py={2} px={3}>
        {(loading && (
          <VStack flex={1} w="100%" justify="center">
            <Spinner emptyColor="gray.100" color="blue.500" size="xl" />
            <Text fontSize="sm">Buscando recursos disponiveis...</Text>
          </VStack>
        )) || (
          <AnimatedBox
            bgGradient={bgGradient}
            borderRadius="lg"
            boxShadow="lg"
            p={{ base: 5, md: 10 }}
            borderWidth={'1px'}
            borderColor={borderColor}
            bg="white"
            w="100%"
            flex={1}
            display="flex"
          >
            <VStack boxSizing="border-box" maxW="lg" spacing={4} w="100%" align="stretch">
              <CardHeaderMobile
                title="Recursos"
                subTitle="Selecione o processo seletivo desejado. Em seguida, serão exibidos os recursos disponíveis para que você possa registrar sua solicitação."
                badgeText="Listagem"
                badgeIcon={<IoDocuments size={12} />}
                colorScheme="blue"
              />
              <VStack spacing={4} align="stretch" h="100%">
                <Box>
                  <InputSelectMobile
                    name="address_state"
                    placeholderLabel="Selecione um processo seletivo"
                    iconLeft={<FaClipboardList size={14} color={accent} />}
                    onChangeItem={setSelected}
                    selectedItem={selected}
                    isExternalState
                    isRequired
                    listItens={selectiveProcessList}
                    fontSize={12}
                  />
                </Box>
                {(listBySelectiveProcess && (
                  <ResourceListMobile resourceList={data} selectiveProcess={listBySelectiveProcess} />
                )) || (
                  <Stack flex={1} align="center" justify="center">
                    <Text fontSize="md" color="gray.400">
                      Selecione um processo seletivo...
                    </Text>
                  </Stack>
                )}
              </VStack>
            </VStack>
          </AnimatedBox>
        )}
      </VStack>
    </Stack>
  );
};

export default ResourceMobilePage;
